import React from "react";
import { Tooltip, Dropdown } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import moment from "moment";
import StatusTag from "../../../../Common/components/StatusTag";
import { makeReasonArray, userCorrectionMap } from "../../utils";
import "./QCCell.css";

const QCCell = ({
  testData,
  user,
  actionItems = [],
  onActionClick,
  // originalTestData,
  readOnly = false,
}) => {
  const {
    ml_correct_by,
    ml_correct_at,
    ml_qc_comments,
    manual_qc_by,
    manual_qc_at,
    manual_qc_assigned_to_name,
  } = testData;

  // Get user correction status safely
  const userCorrectionStatus = (testData.user_correction != null && testData.user_correction !== "" && userCorrectionMap[testData.user_correction])
    || (testData.ml_qc_correction != null && testData.ml_qc_correction !== "" && userCorrectionMap[testData.ml_qc_correction])
    || null;

  // Software QC section
  const reasons = makeReasonArray(testData.qc_status);
  const softwareQCSection = (
    <div className="MarkSampleQCModal__SampleCell__QCSection">
      <div className="MarkSampleQCModal__SampleCell__QCLabelContainer">
        <div className="MarkSampleQCModal__SampleCell__QCLabel">
          Software QC:
        </div>
        <StatusTag result={testData.qc_result} type="QC" />
      </div>
      <div className="MarkSampleQCModal__SampleCell__QCContent">
        {reasons.length ? reasons.map((reason, index_r) => (
          <p key={index_r} className="MarkSampleQCModal__SampleCellTextLight">
            {reason || "-"}
          </p>
        )) : (
          <p className="MarkSampleQCModal__SampleCellTextLight">-</p>
        )}
      </div>
    </div>
  );

  // AI QC tooltip title
  const statusTooltipTitle = (ml_correct_at || ml_correct_by || (ml_qc_comments && ml_qc_comments.trim())) ? () => (
    <span>
      {ml_correct_by && (
        <>
          {ml_correct_by}
          <br />
        </>
      )}
      {ml_correct_at && (
        <>
          {moment(ml_correct_at).format("MM/DD/YYYY, h:mm:ss a")}
          <br />
        </>
      )}
      {ml_qc_comments && ml_qc_comments.trim() && `Comment: ${ml_qc_comments}`}
    </span>
  ) : "";

  // AI QC section (only if user has permission)
  const aiQCSection = user.permissionMap.approve_reject_ml_qc_sendreports ? (
    <div className="MarkSampleQCModal__SampleCell__QCSection">
      <div className="MarkSampleQCModal__SampleCell__QCLabelContainer">
        <div className="MarkSampleQCModal__SampleCell__QCLabel">
          AI QC:
        </div>
        <div className="MarkSampleQCModal__SampleCell__MLQCStatus">
          {statusTooltipTitle ? (
            <Tooltip placement="top" title={statusTooltipTitle}>
              <span>
                <StatusTag result={testData.ml_qc_result} type="QC">
                  {userCorrectionStatus && (
                    <span className="MarkSampleQCModal__UserCorrectionText">
                      &nbsp; -
                      {" "}
                      {userCorrectionStatus}
                    </span>
                  )}
                </StatusTag>
              </span>
            </Tooltip>
          ) : (
            <StatusTag result={testData.ml_qc_result} type="QC">
              {userCorrectionStatus && (
                <span className="MarkSampleQCModal__UserCorrectionText">
                  &nbsp; -
                  {" "}
                  {userCorrectionStatus}
                </span>
              )}
            </StatusTag>
          )}
          {!readOnly && actionItems.length > 0 && (
            <Dropdown
              type="primary"
              menu={{
                items: userCorrectionStatus ? actionItems.filter((actionItem) => actionItem.key !== userCorrectionStatus) : actionItems,
                onClick: onActionClick,
              }}
            >
              <EllipsisOutlined className="MarkSampleQCModal__ActionIcon" />
            </Dropdown>
          )}
        </div>
      </div>
      <div className="MarkSampleQCModal__SampleCell__QCContent">
        <p className="MarkSampleQCModal__SampleCellTextLight">
          {testData.ml_qc_status || "-"}
        </p>
      </div>
    </div>
  ) : null;

  // Manual QC tooltip title
  const manualQCTooltipTitle = () => {
    if (!manual_qc_by && !manual_qc_at && !manual_qc_assigned_to_name) return null;

    return (
      <span>
        {manual_qc_by && (
          <>
            Updated By:
            {" "}
            {manual_qc_by}
            <br />
          </>
        )}
        {manual_qc_at && (
          <>
            Updated At:
            {" "}
            {moment(manual_qc_at).format("MM/DD/YYYY, h:mm:ss a")}
            <br />
          </>
        )}
        {manual_qc_assigned_to_name && (
          <>
            Assigned To:
            {" "}
            {manual_qc_assigned_to_name}
          </>
        )}
      </span>
    );
  };

  // Manual QC section
  const manualQCSection = (
    <div className="MarkSampleQCModal__SampleCell__QCSection">
      <div className="MarkSampleQCModal__SampleCell__QCLabelContainer">
        <div className="MarkSampleQCModal__SampleCell__QCLabel">
          Manual QC:
        </div>
        {manualQCTooltipTitle() ? (
          <Tooltip placement="top" title={manualQCTooltipTitle()}>
            <span>
              <StatusTag result={testData.manual_qc_result} type="MANUAL_QC" />
            </span>
          </Tooltip>
        ) : (
          <StatusTag result={testData.manual_qc_result} type="MANUAL_QC" />
        )}
      </div>
      <div className="MarkSampleQCModal__SampleCell__QCContent">
        <p className="MarkSampleQCModal__SampleCellTextLight">
          {testData.manual_qc_status || "-"}
        </p>
      </div>
    </div>
  );

  return (
    <div className="MarkSampleQCModal__SampleCell">
      {softwareQCSection}
      {aiQCSection}
      {manualQCSection}
    </div>
  );
};

export default QCCell;
